import axios from 'axios'
import config from './config'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URI,
  headers: {
    'Accept': 'application/json',
    'X-Store-Id': config.storeId,
    'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    'X-Zenky-Client': 'web',
    'X-Zenky-Version': process.env.VUE_APP_API_BUILD_VERSION || 'not_specified',
  },
})

export default instance
